import { CheckCircle2, AlertCircle, Lock, Info } from 'lucide-react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';

export default function FieldWrapper({ label, required, error, completed, locked, hint, source, children }) {
  const getStatusIcon = () => {
    if (locked) return <Lock size={14} style={{ color: 'text.secondary' }} />;
    if (error) return <AlertCircle size={14} color="#d32f2f" />;
    if (completed) return <CheckCircle2 size={14} color="#2e7d32" />;
    return null;
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
          {label}
          {required && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
        </Typography>
        {getStatusIcon()}
        {source === 'piattaforma' && (
          <Box
            component="span"
            sx={{
              fontSize: '10px',
              bgcolor: 'primary.light',
              color: 'primary.contrastText',
              px: 1,
              py: 0.25,
              borderRadius: '12px',
              fontWeight: 500,
              opacity: 0.8
            }}
          >
            Auto
          </Box>
        )}
        {hint && (
          <Tooltip title={hint} arrow placement="top">
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
              <Info size={14} style={{ color: '#9e9e9e', cursor: 'help' }} />
            </Box>
          </Tooltip>
        )}
      </Box>
      <Box sx={{ opacity: locked ? 0.7 : 1, pointerEvents: locked ? 'none' : 'auto' }}>
        {children}
      </Box>
      {error && (
        <Typography variant="caption" sx={{ color: 'error.main', mt: 0.5, display: 'block' }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}